import { render } from "./Index.vue?vue&type=template&id=0ab3fabe"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/product-mapping/components/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ab3fabe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ab3fabe', __exports__)) {
    api.reload('0ab3fabe', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=0ab3fabe", () => {
    api.rerender('0ab3fabe', render)
  })

}


export default __exports__